import { Component, Input } from '@angular/core';
import { ControlContainer } from '@angular/forms';

@Component({
  selector: 'ntgr-address-form',
  templateUrl: './address-form.component.html',
})
export class AddressFormComponent {  
  constructor(public controlContainer: ControlContainer) {}
}